export const constants = {
  'Buy hair removial at Vialaser online store An easier way to get your best hair removal package for the best price':
    'Compre depilación láser en la tienda online de Vialaser. Una forma aún más fácil de obtener su mejor paquete de depilación al mejor precio.',
  'hair removal, buy hair removal, hair removal price':
    'depilación láser, comprar depilación láser, depilación láser precio',
};
